import React, { PureComponent } from 'react';

class MobileFilter extends PureComponent {

  onMobileFilterClick(){
    this.props.mobileSelect();
  }

  render(){
    return (
      <div className={`mobileFilter ${this.props.mobileFilterActive ? 'active' : ''}`}>
        <div className="row">
          <div className="columns small-12">
            <button onClick={e => { this.onMobileFilterClick() } }>
              Filter
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 16' className="filter-icon">
                  <defs />
                  <g transform='translate(-73.5 -253.5)'>
                      <line className='filter-icon-line' x2='32' transform='translate(73.5 254.5)' />
                      <line className='filter-icon-line' x2='24' transform='translate(77.5 261.5)' />
                      <line className='filter-icon-line' x2='16' transform='translate(81.5 268.5)' />
                  </g>
              </svg>
            </button>
          </div>
        </div>
    </div>
    )
  }
}

export default MobileFilter;



// WEBPACK FOOTER //
// ./src/components/search/components/filters/mobileFilter.js